import React from 'react';
const pains = [{
  emoji: '🐢',
  title: 'Metabolismo lento',
  desc: 'Comés poco y seguís subiendo de peso. Parece que hasta el agua te engorda.'
}, {
  emoji: '🎈',
  title: 'Hinchazón constante',
  desc: 'Tu panza parece inflada todo el día, especialmente después de comer.'
}, {
  emoji: '🔋',
  title: 'Cansancio extremo',
  desc: 'Te levantás sin energía y terminás el día completamente agotada.'
}, {
  emoji: '🍪',
  title: 'Ansiedad por comer',
  desc: 'No podés parar de picotear, especialmente a la tarde o de noche.'
}, {
  emoji: '📉',
  title: 'Frustración con dietas',
  desc: 'Probaste de todo, bajás un poco y volvés a subir el doble (efecto rebote).'
}, {
  emoji: '👗',
  title: 'Ropa que no entra',
  desc: 'Tu ropa favorita ya no te queda como antes y te frustra vestirte.'
}];
export function PainPoints() {
  return <section className="py-20 bg-bg-warm" data-id="element-156">
      <div className="container mx-auto px-4 max-w-5xl fade-in-section" data-id="element-157">
        <div className="text-center mb-12" data-id="element-158">
          <h2 className="text-3xl md:text-4xl font-bold text-text-dark mb-4" data-id="element-159">
            ¿Te sentís identificada con algo de esto?
          </h2>
          <div className="w-24 h-1 bg-coral mx-auto rounded-full" data-id="element-160"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-161">
          {pains.map((pain, index) => <div key={index} className="bg-white p-6 rounded-2xl shadow-soft border border-gray-100 hover:shadow-card transition-shadow duration-300" data-id="element-162">
              <div className="text-4xl mb-4 bg-blush w-16 h-16 rounded-full flex items-center justify-center" data-id="element-163">
                {pain.emoji}
              </div>
              <h3 className="text-xl font-bold text-text-dark mb-2" data-id="element-164">
                {pain.title}
              </h3>
              <p className="text-text-medium leading-relaxed" data-id="element-165">{pain.desc}</p>
            </div>)}
        </div>

        <div className="text-center bg-rose/10 p-6 rounded-2xl border border-rose/20 max-w-3xl mx-auto" data-id="element-166">
          <p className="text-xl md:text-2xl font-semibold text-coral-dark" data-id="element-167">
            Si dijiste que sí a por lo menos 2 de estas situaciones...{' '}
            <br className="hidden md:block" data-id="element-168" />
            <span className="text-text-dark" data-id="element-169">
              seguí leyendo, porque esto es para vos.
            </span>
          </p>
        </div>
      </div>
    </section>;
}